/* eslint camelcase: 0 */

import { UserParticipantsCollection as Data } from '@/typings/api/User'
import { Model } from '@/helpers/Model'


export class UsersParticipantsModel extends Model<Data> {
}
